import createTheme from "@mui/material/styles/createTheme"
import { deDE } from "@mui/x-data-grid"

export const baseUrl = process.env.REACT_APP_API_URL;

export const authUrl: string = baseUrl + 'Auth/login/'
export const buildingUrl: string = baseUrl + 'Buildings/'
export const freespaceUrl: string = baseUrl + 'Roomspace/'
export const usersUrl: string = baseUrl + 'Users/'


export const pubDir: string = (process.env.NODE_ENV === 'production') ? '/' : '/'
export const theme = createTheme( {}, deDE)